import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import ExpandDetails from 'components/common/expand-details';
import React, { useEffect, useState } from 'react';
import ResultsActionIcons from './results-actions/results-action-icons';
import _ from 'lodash';
import { APPS, QUOTES } from 'components/constants';
import { Avatar } from 'enspire-manager-framework';
import { DashboardDetail } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { imageSize, numPanels, navMultipleUrls } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const moment = require('moment');

const ResultsMyWorkOrders = (props) => {
    
    /* Hooks --------------------------*/
    
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
	const routeLocation = useLocation();

    const user = useSelector((store) => store.users.user);
    const employees = useSelector((store) => store.employees.employees);
    const openQuotes = useSelector((store) => store.quotes.quotes_open);

    const [data, setData] = useState([]);

    const type = (params.appId == APPS.DISPATCH.id) ? 'service_request' : 'asset_request';
    const typeQuotes = _.filter(openQuotes, (quote) => quote['type'] == type);
    const orderedQuotes = _.orderBy(typeQuotes, ['_name'], ['asc']);
	const segments = routeLocation.pathname.split('/').length;
    
    /* UseEffect --------------------------*/

    useEffect(() => {     
        const techQuotes = orderedQuotes?.filter((quote) => quote.ownerId == user.email) || [];
        var quotes_array = [];
        var currentEntityId = null;

        techQuotes?.forEach((quote) => {
            
            const entityId = (params.appId == APPS.DISPATCH.id) ? quote.customerId : quote.assetId;
            const status = _.find(Object.values(QUOTES), { id: quote.statusId });
            const owner = _.find(employees, (o) => o.contact?.email == quote?.ownerId);
            
            // Add grouip heading for customer or asset
            if (entityId != currentEntityId) {
                currentEntityId = entityId;
                quotes_array.push({ ...quote,
                    status: status?.name,
                    _jsx:
                    <div className="d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: '#dddddd' }}>
                        <div role="button" onClick={() => openEntity(quote)}>
                            <Avatar className=""
                                color="white"
                                bgColor="saddleBrown"
                                size={45}
                                fontSize={'20px'}
                                name={(params.appId == APPS.DISPATCH.id) ? quote._displayName : quote._name}
                                image={imageSize(quote._imageUrl, 'sm')}
                                imageWidth={60}
                                border="4px solid white"
                                role={ (quote._imageUrl) ? "button" : null }
                                style={{ flexShrink: 0 }}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <h2 className="ml-3 m-0 text-black font-weight-normal">{
                                ((params.appId == APPS.DISPATCH.id) ? quote._displayName : quote._name) + 
                                ((quote._unitNumber) ? ' #' + quote._unitNumber : '')
                            }</h2>
                            { quote._address &&
                                <p className="ml-3 m-0">{ quote._address }</p>
                            }
                        </div>
                    </div> 
                });
            }

            quotes_array.push({ ...quote,
                status: status?.name,
                _stripe_color: status?.color,
                details: <>
                    <div className="d-flex justify-content-between">
                        <h1 className="main-heading heading-quote align-self-start mx-2">
                            Quote #{quote.customId}
                        </h1>
                        <p className="mb-2 mr-auto">{ moment(quote.effective?.toDate()).format('MMM Do, YYYY') }</p>
                    </div>
                    <div id="quote-details" className="mt-2 mb-2">
                        <DashboardDetail field={ 'Technician Id' } value={ (quote.technicianId != "unassigned") ? quote.technicianId : "UNASSIGNED" } />
                        <DashboardDetail field={ 'Effective Date' } value={ moment(quote.effective?.seconds, 'X') } format='MMM DD, YYYY' type="moment" />
                        <DashboardDetail field={ 'Expiration Date' } value={ moment(quote.expiration?.seconds, 'X') } format='MMM DD, YYYY' type="moment" />
                        <DashboardDetail field={ 'Start Date' } value={ moment(quote.startDate?.seconds, 'X')} format='MMM DD, YYYY h:mm A' type="moment" />
                        <DashboardDetail field={ 'End Date' } value={ moment(quote.endDate?.seconds, 'X')} format='MMM DD, YYYY h:mm A' type="moment" />
                        <DashboardDetail field={ 'Description' } value={ quote.description } type="text" />
                        <DashboardDetail field={ 'Created By' } value={ `${owner?.contact.firstName} ${owner?.contact.lastName}` } type="text" />
                        <div className="clearfix"></div>
                    </div>
                    <div className="d-flex align-items-end justify-content-between">
                        <ResultsActionIcons entity={ 'quote' } quote={ quote } entityId={ quote.id } sms={ false } />
                        <button className="btn btn-default btn-lg btn-circle ml-3" onClick={ () => openQuote(quote) }>
                            <i className="fa-duotone fa-solid fa-chevrons-right"></i>
                        </button>
                    </div>
                </>
            });
        });
        setData(quotes_array);
    }, [openQuotes, routeLocation.pathname]);
    
    /* Actions ----------------------------*/

    const openQuote = async (quote) => {
        let num = (segments >= 11) ? -2 : (segments >= 10) ? -1 : 0;
        if (num) history.go(num);

        const entityId = (params.appId == APPS.DISPATCH.id) ? quote.customerId : quote.assetId;
        navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${quote.serviceRequestId}/quotes`, 9),
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${quote.serviceRequestId}/quotes/${quote.id}/items`, 11),
        ]});
    }
    const openEntity = (quote) => {
        const entityId = (params.appId == APPS.DISPATCH.id) ? quote.customerId : quote.assetId;
        const tab = (params.appId == APPS.DISPATCH.id) ? 'tab' : 'service_requests';

        navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/${tab}`, 7),
        ]});    
    }

    /* Constants --------------------------*/

    const columns = [
        { name: 'Details', field: 'details', type: 'jsx', width: 100 },
    ];
   
    return (
        <Table
            data={data}
            columns={columns}
            active_field={'id'}
            active_id={params.tab2_id}
            group_by={{ fields: ['statusId'], direction: ['desc'], display: ['status'], bgColor: ['bg_color'] }}
            hide_header={true}
        />
    );
};

export default ResultsMyWorkOrders;